module.exports = __webpack_public_path__ + "img/quotysco.10347066.png";